<template>
  <div class="my-inquiry-area">
    <!-- D: 기간설정 -->
    <div class="c-filter-box">
      <div class="c-form-field">
        <label class="c-input-calender">
          <input
            type="text"
            required
            title="시작일"
            data-datepicker
            ref="startDatepickerRef"
            v-model="data.search.startRegDt"
            readonly
          />
        </label>
        <span class="tilde">~</span>
        <label class="c-input-calender">
          <input
            type="text"
            required
            title="종료일"
            data-datepicker
            ref="endDatepickerRef"
            v-model="data.search.endRegDt"
            readonly
          />
        </label>
      </div>

      <div class="c-round-button-box">
        <div class="c-radio-round type-black">
          <input
            type="radio"
            id="filter-date-option7-1"
            name="filter-date-option7"
            @change="dateCalculation('1W')"
            value="1W"
            v-model="data.check.date"
          />
          <label for="filter-date-option7-1">1주일</label>
        </div>
        <div class="c-radio-round type-black">
          <input
            type="radio"
            id="filter-date-option7-2"
            name="filter-date-option7"
            checked
            @change="dateCalculation('1M')"
            value="1M"
            v-model="data.check.date"
          />
          <label for="filter-date-option7-2">1개월</label>
        </div>
        <div class="c-radio-round type-black">
          <input
            type="radio"
            id="filter-date-option7-3"
            name="filter-date-option7"
            @change="dateCalculation('6M')"
            value="6M"
            v-model="data.check.date"
          />
          <label for="filter-date-option7-3">6개월</label>
        </div>
        <div class="c-radio-round type-black">
          <input
            type="radio"
            id="filter-date-option7-4"
            name="filter-date-option7"
            @change="dateCalculation('1Y')"
            value="1Y"
            v-model="data.check.date"
          />
          <label for="filter-date-option7-4">1년</label>
        </div>
      </div>

      <div class="c-btn-area">
        <button
          type="button"
          class="c-util-button type-line-black"
          @click="btnCmd('reset')"
        >
          <span>초기화</span>
        </button>
        <button
          type="button"
          class="c-util-button type-primary"
          @click="searchCmd('search')"
        >
          <span>조회</span>
        </button>
      </div>
    </div>

    <!-- D: tabs -->
    <div class="c-square-tabs col5">
      <ul>
        <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
        <li class="tab-item">
          <button
            type="button"
            @click="btnCmd('tabClick', { tabIndex: 0 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 0,
              },
            ]"
            role="tab"
            aria-selected
          >
            전체
          </button>
        </li>
        <li class="tab-item">
          <button
            type="button"
            @click="btnCmd('tabClick', { tabIndex: 10 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 10,
              },
            ]"
            role="tab"
          >
            주문
          </button>
        </li>
        <li class="tab-item">
          <button
            type="button"
            class="tab-anchor"
            role="tab"
            @click="btnCmd('tabClick', { tabIndex: 20 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 20,
              },
            ]"
          >
            제품
          </button>
        </li>
        <li class="tab-item">
          <button
            type="button"
            class="tab-anchor"
            role="tab"
            @click="btnCmd('tabClick', { tabIndex: 30 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 30,
              },
            ]"
          >
            사이트
          </button>
        </li>
        <li class="tab-item">
          <button
            class="tab-anchor"
            role="tab"
            @click="btnCmd('tabClick', { tabIndex: 40 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 40,
              },
            ]"
          >
            재고문의
          </button>
        </li>
        <li class="tab-item">
          <button
            type="button"
            class="tab-anchor"
            role="tab"
            @click="btnCmd('tabClick', { tabIndex: 50 })"
            :class="[
              'tab-anchor',
              {
                'is-active': data.search.tabIndex === 50,
              },
            ]"
          >
            기타
          </button>
        </li>
      </ul>
    </div>

    <!-- D : 문의내역 리스트 -->
    <div
      class="c-accordion-list type-answer"
      data-accordion-wrap
      v-if="data.inquire.listFlag"
    >
      <ul>
        <li
          v-for="(item, idx) in data.inquire.list"
          :key="idx"
          :id="'ID' + item.otoQstnSn"
        >
          <div style="display: none">
            파람sn {{ data.route.otoQstnSn }} | 펼침인덱스:{{
              data.inquire.expendIndex
            }}
            | 행sn{{ item.otoQstnSn }} |
          </div>
          <!-- :id="'ID' + item.otoQstnSn" -->
          <button
            type="button"
            class="accordion-button"
            data-accordion-trigger
            :aria-expanded="data.inquire.expendIndex === idx"
            :aria-controls="'act' + idx"
            @click="btnCmd('expendClick', { index: idx, item })"
          >
            <span
              v-if="item.qstnTypeCd == 10"
              class="c-flag type-board type-blue"
              >주문</span
            >
            <span
              v-if="item.qstnTypeCd == 20"
              class="c-flag type-board type-teal"
              >제품</span
            >
            <span
              v-if="item.qstnTypeCd == 30"
              class="c-flag type-board type-purple"
              >사이트</span
            >
            <span
              v-if="item.qstnTypeCd == 40"
              class="c-flag type-board type-green"
              >재고문의</span
            >
            <span
              v-if="item.qstnTypeCd == 50"
              class="c-flag type-board type-olive"
              >기타</span
            >
            <span
              :class="
                item.ansList[0] != null
                  ? 'c-flag type-answer type-primary'
                  : 'c-flag type-answer type-gray'
              "
              >{{ item.ansList[0] != null ? "답변완료" : "답변대기" }}</span
            >

            <div class="text-box">
              <strong class="title" v-html="sanitizeHTML(item.qstnCn)"></strong>
              <div class="detail-box" v-if="item.qstnTypeCd == 10">
                <span class="date" v-if="item.orderDt != null"
                  >주문일자 {{ item.orderDt }}</span
                >
                <p class="summary" v-if="item.orderDt != null">
                  {{ item.orderTitle }}
                </p>
                <div v-if="item.orderDt != null">
                  <p
                    class="summary"
                    v-for="(good, idx) in item.goods"
                    :key="idx"
                  >
                    {{ good != null ? good.zzmaktx : null }}
                  </p>
                </div>
              </div>
              <div
                class="detail-box"
                v-if="item.qstnTypeCd == 20 || item.qstnTypeCd == 40"
              >
                <p class="summary" v-for="(good, idx) in item.goods" :key="idx">
                  {{ good != null ? good.zzmaktx : null }}
                </p>
              </div>
              <div
                class="detail-box"
                v-if="item.qstnTypeCd == 30 || item.qstnTypeCd == 50"
              ></div>
              <span class="regist-date">등록일: {{ item.regDt }}</span>
            </div>
          </button>
          <div
            v-if="item.ansList[0] != null"
            :id="'act' + idx"
            class="accordion-content"
            data-accordion-content
            :aria-hidden="data.inquire.expendIndex !== idx"
          >
            <template v-if="item.ansList[0] != null">
              <div
                v-for="(dit, idx) in item.ansList"
                :key="idx"
                class="answer-item"
              >
                <span class="label">[답변]</span>
                <div class="content">
                  <p v-html="sanitizeHTML(dit.ansCn)"></p>
                </div>
                <span class="regist-date">답변 등록일: {{ dit.mdfcnDt }}</span>
              </div>
            </template>
          </div>
        </li>
      </ul>
    </div>
    <!-- // D : 문의내역 리스트 -->

    <!-- D : 문의내역 없는경우 -->
    <div class="c-no-data-box" v-if="!data.inquire.listFlag">
      <div class="icon-box">
        <i class="c-icon icon-nodata size-large"></i>
      </div>
      <div class="text">
        <p>문의 내역이 없습니다.</p>
      </div>
    </div>
    <!-- // D : 문의내역 없는경우 -->

    <!-- D: PC 전용 pageing area -->
    <Pagination
      ref="paginationEl"
      v-if="data.inquire.listFlag"
      :total-pages="data.inquire.totalPage"
      :per-page="data.inquire.limit"
      :show-select="true"
      :page-reload-flag="data.inquire.pageReloadFlag"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
    />
    <!-- // D: PC 전용 pageing area -->

    <div class="c-btn-area has-fixed-visible is-fixed" data-bottom-fixed>
      <a
        href="#"
        class="c-button type-primary flex-auto"
        style="--btn-width: 280px"
        @click="routerCmd()"
      >
        <span>문의작성</span>
      </a>
    </div>

    <!-- 고객 지원 -->
    <div class="c-customer-footer">
      <div class="section">
        <strong class="subject">무엇을 도와드릴까요?</strong>
        <div class="tel-group">
          <p class="text">고객문의</p>
          <p class="tel">
            <a href="tel:080-944-7777">080-944-7777</a>
          </p>
        </div>
        <ul class="inquiry-time">
          <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
          <li>점심시간 - 12:00~13:00</li>
        </ul>
      </div>
      <div class="section">
        <div class="tel-group">
          <p class="text">담당 영업사원</p>
          <p class="tel">
            <a :href="`tel:${data.page.zphoneNo}`"
              >{{ data.page.zempName }} {{ data.page.zphoneNo }}</a
            >
          </p>
        </div>
        <ul class="inquiry-time">
          <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
          <li>점심시간 - 12:00~13:00</li>
        </ul>
      </div>
      <div class="section"></div>
    </div>
  </div>
</template>
<script setup name="inquireListTab">
import {
  onMounted,
  reactive,
  inject,
  ref,
  computed,
  watch,
  nextTick,
} from "vue";
import { api } from "@/plugins/api";
import { useRouter, useRoute } from "vue-router";

import Pagination from "@/components/paintpro/base/pagination.vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import $ from "jquery";

const router = useRouter();
const route = useRoute();
const url = inject("url_prefix");

const startDatepickerRef = ref(null);
const endDatepickerRef = ref(null);
const paginationEl = ref(null);

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    empIndex: 0,
    userLoginInfo: {},
    zempName: null,
    zphoneNo: null,
  },
  inquire: {
    expendIndex: -1,
    list: [],
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    pageReloadFlag: 0,
    loading: false,
    listFlag: true,
  },
  search: {
    startRegDt: "",
    endRegDt: "",
    tabIndex: 0,
  },
  check: {
    date: "",
  },
  detailFlag: false,
  route: {
    otoQstnSn: 0,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  jqueryDatepicker(); // 달력
  dateCalculation("1M");
  pageInit(); // 초기셋팅
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();

  data.route.otoQstnSn = route.params.id;
  if (data.route.otoQstnSn > 0) {
    data.inquire.limit = 100;
    await searchCmd("search", { type: "route" });
    data.inquire.pageReloadFlag++;
  } else {
    await searchCmd("search", { type: "page" });
  }

  goToSelectedPost();
}

/*********************
 * 페이지 초기 데이터 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  const { userLoginInfo } = res.data;
  data.page.userLoginInfo = userLoginInfo;

  if (store.useEventBusStore().salesPersonIndex == data.page.empIndex) {
    data.page.zempName =
      data.page.userLoginInfo.empList[data.page.empIndex].zempName;
    data.page.zphoneNo =
      data.page.userLoginInfo.empList[data.page.empIndex].zphoneNo;
  } else {
    data.page.zempName =
      data.page.userLoginInfo.empList[
        store.useEventBusStore().salesPersonIndex
      ].zempName;
    data.page.zphoneNo =
      data.page.userLoginInfo.empList[
        store.useEventBusStore().salesPersonIndex
      ].zphoneNo;
  }

  searchCmd("search");
}

const datePair = computed(() => [data.search.startRegDt, data.search.endRegDt]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.search.startRegDt = oldStartDate;
      data.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.</br> 다시 확인해주세요."
      );
    }
  }
);

watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (data.page.userLoginInfo?.empList?.length > 0) {
      if (data.page.empIndex != newValue) {
        data.page.empIndex = newValue;
        data.page.zempName = data.page.userLoginInfo.empList[newValue].zempName;
        data.page.zphoneNo = data.page.userLoginInfo.empList[newValue].zphoneNo;
      }
    }
  }
);

watch(
  () => route.params.id,
  async (newValue) => {
    data.inquire.expendIndex = -1;
    data.route.otoQstnSn = newValue;
    data.inquire.limit = 100;
    await searchCmd("search", { type: "route" });
    goToSelectedPost();
    data.inquire.pageReloadFlag++;
  }
);

/**********************
 * 버튼 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 아코디언 활성화
  if (cmd === "expendClick") {
    let item = params.item;
    if (item.ansList[0] == null) {
      cmUtil.toast(`답변 등록 전입니다.`, { type: "basket" });
    } else {
      if (data.inquire.expendIndex == params.index) {
        data.inquire.expendIndex = -1;
      } else {
        data.inquire.expendIndex = params.index;
      }
    }
  }
  // 초기화
  else if (cmd == "reset") {
    data.check.date = "1M";
    await dateCalculation("1M");
  }
  // 카테고리
  else if (cmd === "tabClick") {
    data.search.tabIndex = params.tabIndex;
    searchCmd("search");
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  if (cmd === "search") {
    const res = await api.post(`${url}/utility/userinfo/selectInquireList`, {
      ntcMttrTypeCd: data.search.tabIndex,
      startRegDt: data.search.startRegDt,
      endRegDt: data.search.endRegDt,
      page: params["page"] || 1,
      limit: params["limit"] || data.inquire.limit,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    data.inquire.list = res.data.list;
    data.inquire.page = params["page"] || 1;
    data.inquire.totalCount = res.data.totalCount;
    data.inquire.totalPage = data.inquire.totalCount
      ? Math.ceil(data.inquire.totalCount / data.inquire.limit)
      : 0;

    // 알림에서 클릭하여 들어오는 경우
    if (params.type == "route") {
      if (data.route.otoQstnSn > 0) {
        for (let i in res.data.list) {
          if (res.data.list[i].otoQstnSn == data.route.otoQstnSn) {
            data.inquire.expendIndex = Number(i);
            break;
          }
        }
      }
    } else {
      data.inquire.expendIndex = -1;
    }

    if (res.data.totalCount > 0) {
      data.inquire.listFlag = true;
    } else {
      data.inquire.listFlag = false;
    }
  }
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  searchCmd("search", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.inquire.limit = perPage;
  searchCmd("search", {});
}

/**********************
 * jquery 달력
 *********************/
async function jqueryDatepicker() {
  if (startDatepickerRef.value == null) return;
  $(startDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "-1D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.startRegDt = dateText;
      data.check.date = "";
    },
  });

  // 종료일
  if (endDatepickerRef.value == null) return;
  $(endDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "0D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.endRegDt = dateText;
      data.check.date = "";
    },
  });
}

/**********************
 * 등록일 버튼 모음
 *********************/
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "1W":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "1M":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "6M":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "1Y":
      resultDate.setDate(today.getDate() - 364);
      break;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);

  data.search.startRegDt = resultDate;
  data.search.endRegDt = todayDate.value;
  data.check.date = period;
}

/**********************
 * router
 *********************/
async function routerCmd() {
  router.push({
    name: "/paintpro/custCenterList/reqList",
  });
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}

// 아코디언 열린 위치로 스크롤 이동
const goToSelectedPost = () => {
  nextTick(() => {
    const id = route.params.id || "";
    if (id) {
      const idEl = document.getElementById(`ID${id}`);
      let positionTop = idEl?.getBoundingClientRect().top || 0;
      if (positionTop > 100) {
        positionTop -= 95;
      }
      window.scroll({ top: positionTop });
    }
  });
};
</script>
<style scoped></style>
